import React from 'react';
import ScheduleBuilder from '@/components/ScheduleBuilder';
import ScrollReveal from '@/components/ScrollReveal';

const Schedule = () => {
  return (
    <div className="pt-24 pb-16">
      <ScrollReveal>
        <ScheduleBuilder />
      </ScrollReveal>
    </div>
  );
};

export default Schedule;
